/*
 * カートドロワーの配送日時欄(配送日時アプリ cc-delivery-date-time が差し込む #cc-calendar-overall)を
 * 開閉式にする(2026-10-16 ユーザー指示)。SPは閉じた状態、PCは開いた状態で始まる。
 *
 * アプリは日時欄をカート更新(数量変更・商品追加)のたびに .drawer__footer へ差し込み直し、
 * Dawnもドロワーの中身を丸ごと描き直す。そのため開閉ボタンは一度置いて終わりにせず、
 * 日時欄が現れるたびに直前へ置き直す。開閉の状態はページ内で保持し、描き直し後も引き継ぐ。
 *
 * あわせて、日時欄が出るまで「購入手続きに進む」を押せなくする(2026-10-16 ユーザー指示)。
 * アプリはカートを開いてから少し遅れて日時欄を差し込むため、その前に購入手続きへ進むと
 * 配送日時を選ぶ機会がなかった。待っている間はボタンに「配送日時を読み込み中…」と出す。
 * アプリが読み込めない障害時に購入できなくならないよう、10秒待っても出なければ押せるように戻す。
 */
(function () {
  const drawer = document.querySelector('cart-drawer');
  const template = document.getElementById('NySodaDeliveryToggle');
  if (!drawer || !template) return;

  let open = window.matchMedia('(min-width: 750px)').matches;
  const LOADING_LABEL = template.dataset.loadingLabel || '';
  const GIVE_UP_MS = 10000;
  let gaveUp = false;
  let giveUpTimer = null;

  // 日時欄が出るまで購入手続きボタンを押せなくする(カートが空のときはDawnの disabled のまま触らない)
  const syncCheckout = () => {
    const button = drawer.querySelector('#CartDrawer-Checkout');
    if (!button) return;
    const empty = drawer.classList.contains('is-empty');
    const waiting = !empty && !gaveUp && !findCalendar();
    if (waiting) {
      if (!button.hasAttribute('data-ny-soda-waiting')) {
        button.setAttribute('data-ny-soda-waiting', '');
        button.dataset.nySodaLabel = button.textContent.trim();
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (LOADING_LABEL) button.textContent = LOADING_LABEL;
      }
      if (!giveUpTimer) {
        giveUpTimer = setTimeout(() => {
          gaveUp = true;
          giveUpTimer = null;
          syncCheckout();
        }, GIVE_UP_MS);
      }
      return;
    }
    clearTimeout(giveUpTimer);
    giveUpTimer = null;
    if (button.hasAttribute('data-ny-soda-waiting')) {
      if (button.dataset.nySodaLabel) button.textContent = button.dataset.nySodaLabel;
      button.removeAttribute('data-ny-soda-waiting');
      button.removeAttribute('aria-busy');
      if (!empty) button.disabled = false;
    }
  };

  const findCalendar = () => drawer.querySelector('.drawer__footer > #cc-calendar-overall');

  // 選んだ内容を閉じたままでも分かるように、ボタンの右側へ要約を出す
  const summarize = (calendar, valueEl) => {
    const unspecified = valueEl.dataset.unspecified;
    const parts = [];
    const region = calendar.querySelector('#cc-select-days-opt');
    if (region && region.value) parts.push(region.value);
    const date = calendar.querySelector('#cc-calendar-input-column');
    if (date && date.value && date.value !== unspecified) parts.push(date.value);
    const time = calendar.querySelector('#cc-time-options');
    if (time && time.selectedIndex > 0 && time.value) parts.push(time.options[time.selectedIndex].text.trim());
    valueEl.textContent = parts.length ? parts.join('・') : unspecified;
  };

  const sync = () => {
    syncCheckout();
    const calendar = findCalendar();
    if (!calendar) return;
    let toggle = calendar.previousElementSibling;
    if (!toggle || !toggle.classList.contains('ny-soda-delivery-toggle')) {
      drawer.querySelectorAll('.ny-soda-delivery-toggle').forEach((stale) => stale.remove());
      toggle = template.content.firstElementChild.cloneNode(true);
      calendar.before(toggle);
    }
    if (toggle.getAttribute('aria-expanded') !== String(open)) toggle.setAttribute('aria-expanded', String(open));
    calendar.closest('.drawer__footer').classList.toggle('ny-soda-delivery-open', open);
    summarize(calendar, toggle.querySelector('.ny-soda-delivery-toggle__value'));
  };

  drawer.addEventListener('click', (event) => {
    if (event.target.closest('.ny-soda-delivery-toggle')) {
      open = !open;
      sync();
      return;
    }
    // カレンダーで日付を選んだあとなどに要約を更新する(アプリの処理が終わってから読む)
    if (event.target.closest('#cc-calendar-overall')) setTimeout(sync, 50);
  });
  drawer.addEventListener('change', (event) => {
    if (event.target.closest('#cc-calendar-overall')) sync();
  });

  // アプリ側で必須項目にされた場合、閉じたままだと入力を促せないため開く
  document.addEventListener(
    'invalid',
    (event) => {
      if (!open && event.target.closest && event.target.closest('#cc-calendar-overall')) {
        open = true;
        sync();
      }
    },
    true
  );

  // 日時欄の差し込み直し・ドロワーの描き直しを検知して置き直す
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      sync();
    });
  }).observe(drawer, { childList: true, subtree: true });

  sync();
})();
